import Vue from 'vue'
import App from './App.vue'
import 'amfe-flexible';
import './assets/css/reset.css' /*引入公共样式*/
import './assets/css/iconfont.css'

// 引入vant
import './lib/vant'
import 'vant/lib/index.css'

// 引入路由
import router from './router/index'

// 引入 vuex文件
import store from './store/index'

// 引入less
import less from 'less'
Vue.use(less)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
